import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { Fragment, memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import Form from './form';
import { LastStepVM, DocumentVM } from 'civil-status/view-models/step-form';

interface DocumentEmergencyProps {
  formContext: FormikProps<LastStepVM>;
  idEvento?: number;
  disabled?: boolean;
}

const DocumentEmergencyComponent = ({
  formContext,
  idEvento,
  disabled,
}: DocumentEmergencyProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const valuesData: DocumentVM | undefined = useMemo(() => {
    return formContext.values.documentEmergencyAct as DocumentVM | undefined;
  }, [formContext.values.documentEmergencyAct]);

  const onChange = useEventCallback(
    (key: keyof DocumentVM, value: DocumentVM[keyof DocumentVM]) => {
      formContext.setFieldValue('documentEmergencyAct', {
        ...((valuesData || {}) as DocumentVM),
        [key]: value,
      });
    }
  );

  const onChanges = useEventCallback((valuesCurr: DocumentVM) => {
    formContext.setFieldValue('documentEmergencyAct', {
      ...((valuesData || {}) as DocumentVM),
      ...valuesCurr,
    });
  });

  const errorFiles = useMemo(() => {
    return !Boolean(valuesData?.file?.idAllegato);
  }, [valuesData?.file]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="accordion-attachments-content"
          id="accordion-attachments-header"
          expandIcon={<ExpandMore />}
        >
          <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Caricamento atto in emergenza firmato &nbsp;
            {errorFiles ? <Close color="error" /> : <Check color="success" />}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form
            onChange={onChange}
            onChanges={onChanges}
            idEvento={idEvento}
            disabled={disabled}
            errorFiles={errorFiles}
            values={valuesData}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

DocumentEmergencyComponent.displayName = 'Accordion Document Emergency Component';

const DocumentEmergency = memo(DocumentEmergencyComponent);

export default DocumentEmergency;
